import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";

export const useGetCancelTimer = () => {
  const { user, siteId } = useAuth();
  const [getRecords] = useLazyReadMultipleQuery();
  const [cancelTimer, setCancelTimer] = useState<number | null>(null);

  useEffect(() => {
    getCancelTimer();
    // eslint-disable-next-line
  }, [user]);

  const getCancelTimer = (): Promise<void> => {
    return getRecords({
      userId: user?.contactId || user?.entityId,
      portalId: siteId || "",
      tableId: "slcm_configurator",
      fieldList: ["edtec365_cancellationtimer"],
      filters: [
        {
          group: 0,
          filters: [
            {
              field: "slcm_name",
              type: FieldFilterType.Const,
              value: "Gate Pass",
            },
          ],
        },
      ],
    })
      .unwrap()
      .then((data) => {
        const record = data.records[0];
        const timer = record["edtec365_cancellationtimer"];
        if (record) {
          setCancelTimer(timer as number);
        }
      });
  };

  return { cancelTimer };
};